import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ISearchInputProps } from '../../../interfaces/interfaces';

function SearchInput(props: ISearchInputProps): JSX.Element {
  const { t } = useTranslation();
  const { inputName, searchParams, onSubmit, className, onChange, id } = props;

  const searchInputRef = useRef<HTMLInputElement>(null);
  const [showReset, setShowReset] = useState(false);
  const [searchString, setSearchString] = useState('');

  const [focused, setFocused] = React.useState(false);
  const onFocus = () => setFocused(true);
  const onBlur = () => setFocused(false);

  const onChangeSearchString = () => {
    setSearchString(searchInputRef.current?.value || '');
    if (onChange) {
      onChange(searchInputRef.current?.value || '');
    }
    if (searchInputRef.current?.value) {
      setShowReset(true);
    } else {
      setShowReset(false);
    }
  };

  const resetSearch = () => {
    setSearchString('');
    setShowReset(false);
    searchInputRef.current?.focus();
    if (onChange) {
      onChange('');
    }
  };

  const OnSubmit = () => {
    onSubmit(searchInputRef);
  };

  return (
    <div className={`search-input-wrapper focus-input ${focused ? 'focus' : ''}`}>
      <input
        type="text"
        name={inputName}
        className={className}
        placeholder={t('cockpit.search.input.placeholder', { defaultValue: 'Suchbegriff eingeben' })}
        ref={searchInputRef}
        value={searchString}
        onChange={onChangeSearchString}
        onFocus={onFocus}
        onBlur={onBlur}
        autoComplete="off"
        id={id || ''}
      />

      {(searchParams || []).map((sp) => {
        return <input type="hidden" key={sp.key} name={sp.key} value={sp.value} />;
      })}

      <button
        onClick={OnSubmit}
        type="button"
        className="ic-search search__submit"
        arial-label={t('cockpit.search.input.search', { defaultValue: 'Suchen' })}
      />

      {showReset && (
        <button
          type="button"
          className="ic-close search__reset "
          aria-label={t('cockpit.search.input.clear', { defaultValue: 'Suche leeren' })}
          onClick={resetSearch}
        />
      )}
    </div>
  );
}
export default SearchInput;
